import { InputBase, makeStyles } from "@material-ui/core";
import React from "react";
import SvgIcon from "../icons";
const SearchBar = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.SearchBox}>
      <InputBase className={classes.input} placeholder="search" {...props} />
      <SvgIcon search width="24.75px" />
    </div>
  );
};

export default SearchBar;
const useStyles = makeStyles((theme) => ({
  SearchBox: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: "11px",
    padding: "5px 10px 5px 15px",
    gap: "20px",
    "& .MuiInputBase-input": {
      color: "black",
    },
  },
  input: {
    width: "100%",
  },
}));
